import Viewports from '../../components/fsUtils/Viewports';
import VideoUtils from '../../components/fsUtils/videoUtils';

 /**
  * Lazy load video
  * Platform video JS is not loaded until users click on the image place holders
  * When users click on video icon on an image, we hide that image and inject
  * class name platformPlayer into the DOM, and then we initialize Video JS loader
  * 
  */

 class LazyLoadVideo {

     constructor() {
         this.viewport = new Viewports();
         this.loader = null;
         VideoUtils.loadVideoPlayer(this.loadVideoPlayer.bind(this));
     }

     /**
      *  initialize the video loader
      */
     initVideoLoader() {
         //get global criticalVideoLoader for the first time init
         this.loader = this.loader || window.criticalVideoLoader;

         if (this.loader !== 'undefined') {

             //get video config data.
             let configData = this.loader.getVideoElementsData().map((data) => { return data; });

             if (configData) {
                 /**
                  * passing third param true to loadVideos event in criticalVideoLoader.js to indicate that we want to
                  * track page view for the video as soon as it is clicked.
                  */
                 this.loader.loadScript(this.loader.loadVideos.bind(this.loader), configData, true);
             }
         }
     }

     loadVideoPlayer(video, isFscPage, isModal) {

        if(isModal) return;

        let player = video.querySelector('.fs-video-player'); // video player
        if ( player && !video.classList.contains('loaded')) {
            if (player && !player.classList.contains('platformPlayer')) {
                player.classList.add('platformPlayer');
                this.handleCardChildren(video, player, isFscPage);
                this.initVideoLoader();
                video.classList.add('loaded'); //add classname to make sure video is already loaded
            }
        }
    }


     /**
      * Handles Section Front card children by hiding elements within the container to be replaced by the video player
      * @param {element} video - video element div
      * @param {element} player - player element div 
      * @param {element} isBB - bb player div
      */
     handleCardChildren(video, player, isFscPage) {
        // tags
        let link = undefined;
        let meta = undefined;

        if (isFscPage) {
            link = video.querySelector('[class*=ImageContainer]'); // thumbnail/link
            meta = video.querySelector('[class*=DetailsContainer]'); // meta/title
            if (meta) {
                if (meta.parentElement.classList.contains('wisbb_topStory')) {
                    meta.style.display = 'none';
                }
            }
        } else {
            link = video.querySelector('.trending-item-link'); // thumbnail/link
            meta = video.querySelector('.trending-item-meta'); // meta/title

            let isSmall = video.classList.contains('small'); // check card size
            let isSectionFeatures = video.parentNode.parentNode.classList.contains('section-features'); // check if its in trending feature
            let isCollections = document.querySelector('.collections-section-front');
            if (this.viewport.getViewPort() !== 'mobile' && (!isSmall || isSectionFeatures) && !isCollections) { meta.style.display = 'none'; } // hide the meta/title
        }
        if (link) {
            player.style.height = link.clientHeight + 'px';
            player.style.width = link.clientWidth + 'px';
            link.style.display = 'none';
        }
     }

     /**
      * EventListener when users click on video player icon on an image
      * @param event
      */
     toggleVideoPlayer(event) {

         event.stopPropagation();
         event.preventDefault();

         let elem = event.currentTarget;
         let imageHolder = elem.children[0];
         let fsPlayer = elem.children[1];
         let platformPlayer = fsPlayer.querySelector('.gallery-video-player');

         //only run this block code if the platformPlayer is not rendered yet, meaning there is no 'tpPlayer' class name
         if (!platformPlayer.classList.contains('tpPlayer')) {
             //hide the image
             imageHolder.style.display = 'none';
             //show the video player
             platformPlayer.style.display = 'block';
             /**
              * inject platformPlayer class name into the DOM
              * class selector platformPlayer is what video loader looks for to initialize the video
              */
             platformPlayer.classList.add('platformPlayer');

             //start the video
             this.initVideoLoader();
         }
     }

     /**
      * initialize click event on all video placeholders
      */
     addClickListeners(selector) {

         if (selector) {
             let count = selector.length;

             //if there are video place holders, wire click event listeners
             if (count > 0) {
                 for (let i = 0; i < count; i++) {
                     selector[i].addEventListener('click', this.toggleVideoPlayer.bind(this));
                 }
             }
         }

     }
 }

 export default new LazyLoadVideo();